<template>
  <el-dialog
    top="50px"
    width="400px"
    :title="`Thẻ tags của ${item.extra.name}`"
    :visible="visible"
    :show-close="!callingAPI"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('close')"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="{}"
      :show-message="true"
      size="medium"
      label-position="top"
    >
      <el-row
        type="flex"
        align="start"
        class="flex-wrap"
        :gutter="12"
      >
        <el-col
          :lg="24"
          :span="24"
        >
          <el-form-item
            prop="tag_ids"
            label="Danh sách thẻ tags"
          >
            <el-select
              v-model="form.tag_ids"
              class="w-100"
              placeholder="Chọn Tags"
              filterable
              multiple
              :disabled="callingAPI"
            >
              <el-option
                v-for="c in tags"
                :key="c.id"
                :label="c.extra.name"
                :value="c.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        :disabled="callingAPI"
        size="medium"
        @click="$emit('close')"
      >
        Đóng
      </el-button>
      <el-button
        type="primary"
        :loading="callingAPI"
        size="medium"
        @click="handleConfirm"
      >
        Lưu
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import tagServices from "@/services/tag";
import commonServices from "@/services/common";
import organizationServices from "@/services/organization"
import { notification, convertPayloadData } from "@/utils/common";

export default {
  name: "TagFormPopup",
  props: {
    item: Object,
    config: Object,
    object: Object,
    visible: Boolean,
    itemRelations: Array,
  },
  data() {
    return {
      loading: false,
      searchText: "",
      tags: [],
      form: {
        tag_ids: this.item?.tag_ids || [],
      },
      callingAPI: false,
      organizationId: organizationServices.getCurrentOrg()?.id
    };
  },
  computed: {
    params() {
      const _params = {
        offset: 0,
        limit: 999,
        locale: "vi",
        filters: {
          organization_id: this.organizationId,
        }
      };
      return _params;
    },
  },
  beforeMount() {
    this.listData();
  },
  methods: {
    listData() {
      this.loading = true;
      tagServices
        .list(this.params)
        .then((response) => {
          this.tags = response.items;
          this.loading = false;
        })
        .catch(() => {
          this.tags = [];
          this.loading = false;
        });
    },
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.callingAPI = true;
          commonServices
            .update(
              this.config.type,
              convertPayloadData(this.item.type, {
                ...this.item,
                tag_ids: this.form.tag_ids
              })
            )
            .then(async () => {
              notification(
                this,
                "success",
                "update",
                `${this.item.extra.name}`
              );
              this.callingAPI = false;
              this.$emit("reload");
              this.$emit("close");
            })
            .catch(() => {
              this.callingAPI = false;
              notification(this, "error", "update", `${this.item.extra.name}`);
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
